const dark = `#080808`
const gray = `#4B4F54`
const red = `#8A5BF0`
export default {
  colors: {
    text: dark,
    primary: red,
    secondary: gray,
    heading: dark,
    background: '#fff',
  },
}